<template>
    <div v-if="show" class="w-full">
    <!-- Desktop action bar -->
    <div
        :class="[desktopPaddingTop, 'w-full hidden md:flex flex-col items-start gap-2']"
    >
        <button
            type="button"
            @click="$emit('primary')"
            class="w-full px-4 py-2.5 rounded bg-[#FD421D] text-white font-medium shadow"
            :disabled="disabled"
        >
            {{ primaryLabel }}
        </button>
        <button
            v-if="secondaryLabel"
            type="button"
            @click="$emit('secondary')"
            class="w-full px-4 py-2.5 rounded text-slate-800 font-medium"
            :disabled="disabled"
        >
            {{ secondaryLabel }}
        </button>
    </div>

    <!-- Mobile fixed bottom action bar -->
    <div
        class="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white px-4 pt-3"
        :style="{ paddingBottom: 'calc(env(safe-area-inset-bottom) + 16px)' }"
    >
        <button
            type="button"
            @click="$emit('primary')"
            class="w-full px-4 py-3 rounded bg-[#FD421D] text-white font-medium shadow"
            :disabled="disabled"
        >
            {{ primaryLabel }}
        </button>
        <button
            v-if="secondaryLabel"
            type="button"
            @click="$emit('secondary')"
            class="w-full mt-2 text-slate-800 font-medium text-center"
            :disabled="disabled"
        >
            {{ secondaryLabel }}
        </button>
    </div>
    </div>
</template>

<script setup>
defineProps({
    primaryLabel: { type: String, required: true },
    secondaryLabel: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    show: { type: Boolean, default: true },
    desktopPaddingTop: { type: String, default: 'pt-12' },
});

defineEmits(['primary', 'secondary']);
</script>
